module.exports = __webpack_public_path__ + "static/media/ELS50FL00.336fb53f.png";